export const PREDECISION_GATEWAY_EVENT_PROMISES = "RCB/PreDecision/Promises";
